import {
  REQUEST_LANDING,
  RECEIVE_LANDING,
} from 'config/types';

export default function landingReducer(state = {}, { type = '', payload } = {}) {
  if (REQUEST_LANDING === type) {
    return {
      ...state,
      isFetching: state.isFetching.concat(payload.key),
    };
  }
  if (RECEIVE_LANDING === type &&
    ('usdata' === payload.key || 'international' === payload.key)
  ) {
    return {
      ...state,
      landingMeta: { ...state.landingMeta, [payload.key]: payload.data },
      isFetching: state.isFetching.filter((x) => payload.key !== x),
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/landing.js